var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"side-page"},[_c('div',{staticClass:"side-page-side"},[_vm._t("side")],2),_c('div',{staticClass:"side-page-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }